// Avatar — a single component so the visual grammar stays consistent.
// `me={true}` renders the current visitor's warm-ochre beacon; anyone
// else stays on the quiet cream palette so ochre uniquely means "me".

import { ME_AVATAR, OTHER_AVATAR, initials } from "../lib/display";

export function Avatar({ name, size = "btn", as = "button", me = false, className: extra = "", ...rest }) {
  const palette = me ? ME_AVATAR : OTHER_AVATAR;
  const base = size === "lg" ? "c-avatar-lg" : "c-avatar-btn";
  const cls = `${base}${extra ? ` ${extra}` : ""}`;
  const style = { background: palette.bg, color: palette.fg, borderColor: palette.border };
  if (as === "div") {
    return (
      <div className={cls} style={style} aria-hidden="true" {...rest}>
        {initials(name)}
      </div>
    );
  }
  return (
    <button className={cls} style={style} {...rest}>
      {initials(name)}
    </button>
  );
}
